import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiAdmin, tokenStore, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = tokenStore.getAdmin();
    if (!t) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await apiAdmin.get("/auth/me");
      setUser(data);
    } catch {
      tokenStore.clearAdmin();
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    try {
      const { data } = await apiAdmin.post("/auth/login", { email, password });
      tokenStore.setAdmin(data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const register = async (name, email, password) => {
    try {
      const { data } = await apiAdmin.post("/auth/register", { name, email, password });
      tokenStore.setAdmin(data.token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const logout = async () => {
    try {
      await apiAdmin.post("/auth/logout");
    } catch {
      /* ignore */
    }
    tokenStore.clearAdmin();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
